import React, {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {isAuthenticated} from '../../redux/slices/userSlice';

const Home: React.FC = () => {
  const isUserAuthenticated = useSelector(isAuthenticated);
  const navigate = useNavigate();
  useEffect(() => {
    if (isUserAuthenticated) {
      navigate('/welcome-multi-client');
    } else {
      navigate('/login');
    }
  }, []);

  return <></>;
};

export default Home;
